import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2, Circle, FileText, Sparkles } from "lucide-react";
import { IMPLEMENTATION_PREVIEW } from "../portalPreviewData";

export default function ImplementationTrackerPreview() {
  const { phases, metrics, templates } = IMPLEMENTATION_PREVIEW;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-bold text-foreground">Implementation Tracker</h2>
        <p className="text-sm text-muted-foreground">Where onboarding stands, and the ROI you're capturing along the way.</p>
      </div>

      <Card>
        <CardContent className="pt-5">
          <div className="flex items-center justify-between">
            {phases.map((p, i) => (
              <React.Fragment key={p.key}>
                <div className="flex flex-col items-center gap-1.5 text-center">
                  {p.done ? (
                    <CheckCircle2 className="w-6 h-6 text-emerald-600" />
                  ) : p.current ? (
                    <Circle className="w-6 h-6 text-secondary fill-secondary/20" />
                  ) : (
                    <Circle className="w-6 h-6 text-muted-foreground/40" />
                  )}
                  <span className={`text-xs ${p.current ? "font-semibold text-foreground" : "text-muted-foreground"}`}>{p.label}</span>
                </div>
                {i < phases.length - 1 && <div className={`flex-1 h-0.5 mx-1 ${p.done ? "bg-emerald-600" : "bg-border"}`} />}
              </React.Fragment>
            ))}
          </div>
        </CardContent>
      </Card>

      <div className="grid grid-cols-3 gap-4">
        <Card>
          <CardContent className="pt-5">
            <p className="text-2xl font-bold text-foreground">{metrics.hoursSavedPerMonth}</p>
            <p className="text-xs text-muted-foreground mt-1">Hours saved / month</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="pt-5">
            <p className="text-2xl font-bold text-foreground">{metrics.docsCompleted}</p>
            <p className="text-xs text-muted-foreground mt-1">Documents completed</p>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="pt-5">
            <p className="text-2xl font-bold text-emerald-600">${metrics.monthlySavings.toLocaleString()}</p>
            <p className="text-xs text-muted-foreground mt-1">Est. monthly savings (${metrics.qaHourlyRate}/hr QA rate)</p>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardContent className="pt-5 space-y-2.5">
          <p className="text-sm font-semibold text-foreground mb-1">Templates</p>
          {templates.map((t) => (
            <div key={t.id} className="flex items-center gap-2.5 text-sm p-2.5 rounded-lg border border-border/60">
              {t.type === "prompt" ? (
                <Sparkles className="w-4 h-4 text-secondary shrink-0" />
              ) : (
                <FileText className="w-4 h-4 text-muted-foreground shrink-0" />
              )}
              <span className="text-foreground">{t.name}</span>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
